(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-cart"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {
        const c = document.getElementById("checkout-buttons");
        if (!c) return;
        const n = c.children.length;
        if (!n) return;
        const w = 100 / n;
        [...c.children].forEach(el => el.style.width = w + "%");
    });
  } catch(e) { console.error(e); }
})();

})();
